/* Native scrolling and video; no global styles, dependencies, or autoplay. */
(() => {
  if (!customElements.get('md-journey-carousel')) {
    class MDCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.md-journey-carousel-track');
        if (!this.track || this.controller) return;
        this.controller = new AbortController();
        const {signal} = this.controller;
        this.originals = Array.from(this.track.children).filter(el => !el.hasAttribute('data-md-journey-clone'));
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const cards = this.originals;
          const stride = (cards[1]?.offsetLeft - cards[0]?.offsetLeft) || cards[0]?.getBoundingClientRect().width || 300;
          const motion = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
          if (event.key === 'Home' || event.key === 'End') this.centerCard(cards[event.key === 'Home' ? 0 : cards.length - 1], motion);
          else this.track.scrollBy({left: event.key === 'ArrowRight' ? stride : -stride, behavior: motion});
        }, {signal});
        if (this.dataset.centered && this.originals.length) {
          // Decorative edge copies keep the centered desktop composition without
          // duplicating reviews for assistive technologies or the theme editor.
          if (this.originals.length > 1) {
            const makeClone = node => {
              const clone = node.cloneNode(true);
              clone.setAttribute('data-md-journey-clone', ''); clone.setAttribute('aria-hidden', 'true'); clone.inert = true;
              clone.removeAttribute('data-shopify-editor-block');
              clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
              return clone;
            };
            this.track.prepend(makeClone(this.originals[this.originals.length - 1]));
            this.track.append(makeClone(this.originals[0]));
          }
          const index = Math.max(0, Math.min(this.originals.length - 1, Number(this.dataset.initial) || 0));
          this.activeCard = this.originals[index];
          this.resizeObserver = new ResizeObserver(() => this.centerCard(this.activeCard));
          this.resizeObserver.observe(this);
          document.fonts.ready.then(() => {if (this.isConnected) this.centerCard(this.activeCard);});
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => {
              const center = this.track.scrollLeft + this.track.clientWidth / 2;
              const nearest = Array.from(this.track.children).reduce((best, el) => Math.abs(el.offsetLeft + el.offsetWidth / 2 - center) < Math.abs(best.offsetLeft + best.offsetWidth / 2 - center) ? el : best);
              if (nearest.hasAttribute('data-md-journey-clone')) {
                this.activeCard = nearest === this.track.firstElementChild ? this.originals.at(-1) : this.originals[0];
                this.centerCard(this.activeCard);
              } else this.activeCard = nearest;
            }, 150);
          }, {signal, passive: true});
        }
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) this.centerCard(event.target.closest('.md-journey-story-card, .md-journey-review-card'));
        }, {signal});
      }
      centerCard(card, behavior = 'instant') {
        if (!card) return;
        const left = card.offsetLeft - this.track.offsetLeft - (this.dataset.centered ? (this.track.clientWidth - card.offsetWidth) / 2 : parseFloat(getComputedStyle(this.track).paddingLeft));
        this.track.scrollTo({left, behavior});
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        this.resizeObserver?.disconnect(); clearTimeout(this.scrollTimer);
        this.querySelectorAll('[data-md-journey-clone]').forEach(el => el.remove());
      }
    }
    customElements.define('md-journey-carousel', MDCarousel);
  }
  if (!customElements.get('md-journey-video')) {
    class MDVideo extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button'), video = this.querySelector('video');
        if (!button || !video || this.controller) return;
        this.controller = new AbortController(); const {signal} = this.controller;
        button.addEventListener('click', async () => {
          try {await video.play(); this.dataset.playing = ''; video.focus();}
          catch {this.removeAttribute('data-playing');}
        }, {signal});
        video.addEventListener('ended', () => this.removeAttribute('data-playing'), {signal});
      }
      disconnectedCallback() {this.controller?.abort(); this.controller = null; this.querySelector('video')?.pause();}
    }
    customElements.define('md-journey-video', MDVideo);
  }
})();
